<template>
  <div class="wrapper">
    <base-circular-loader v-if="loading" />

    <div v-else class="list">
      <div v-for="(category, index) in categories"
          :key="index"
          class="list-item list-item-no-border list-item-sm">
        <content-filter-item :category="category"
                             :child-id="childId"
                             :modeId="modeId"
                             @changeAction="changeAction" />
      </div>
    </div>
  </div>
</template>

<script>
  import ContentFilterItem from '@/components/Child/ChildContentFilter/ContentFilterItem'

  import analytics from '@/services/analytics.js'

  export default {
    props: {
      modeId: {
        type: String,
        required: true
      },

      childId: {
        type: String,
        required: true
      }
    },

    components: {
      ContentFilterItem
    },

    data() {
      return {
        loading: true
      }
    },

    created() {
      analytics.sendEvent('FiltSet_Sc')

      this.loadCategorySettings()
    },

    methods: {
      ...mapActions('children', {
        setCategorySettings: 'setCategorySettings',
        updateCategorySettings: 'updateCategorySettings'
      }),

      async loadCategorySettings() {
        this.loading = true

        await this.setCategorySettings({
          user_id: this.childId,
          mode_id: this.modeId
        })

        this.loading = false
      },

      changeAction(category) {
        const { id, action } = category

        this.updateCategorySettings({
          user_id: this.childId,
          mode_id: this.modeId,
          category_id: id,
          action
        })
      }
    },

    computed: {
      ...mapGetters('categories', {
        categories: 'get'
      })
    }
  }
</script>
